import gql from 'graphql-tag';

const externalProductCatalogQuery = gql`
  query externalProductCatalog {
    externalProductCatalog {
      productCode
      displayName
      description
    }
  }
`;

export default externalProductCatalogQuery;
